// src/App.js
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useState, useEffect } from "react";
import HomeResolver from "./pages/HomeResolver";
 

import "./App.css";
import "./mobile.css";
 
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { EvaluationProvider } from "./contexts/EvaluationContext";
 
import AccountPage from "./pages/AccountPage";
import Dashboard from "./pages/Dashboard";
import EvaluationDashboard from "./pages/EvaluationDashboard";
import EvaluationPage from "./pages/EvaluationPage";
import Learning from "./pages/Learning";
import LoginPage from "./pages/LoginPage";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import PrivacyPage from "./pages/PrivacyPage";
import Purchase from "./pages/Purchase";
import ReportPage from "./pages/ReportPage";
import TOSPage from "./pages/TOSPage";
import NoAccessPage from "./pages/Access";
 
import EvaluationTest from "./components/Evaluation/EvaluationTest";
import UserManagement from "./pages/UserManagePage";
import RoleManagement from "./pages/RolePage";


function App() {
  const [userPermissions, setUserPermissions] = useState([]);
 
  // ===============================
  // Load permissions from localStorage
  // ===============================
  useEffect(() => {
    const loadPermissions = () => {
      const permissions = localStorage.getItem("userPermissions");
 
      if (permissions) {
        try {
          setUserPermissions(JSON.parse(permissions));
        } catch (err) {
          console.error("Failed to parse permissions:", err);
          setUserPermissions([]);
        }
      } else {
        setUserPermissions([]);
      }
    };
 
    loadPermissions();
 
    // Listen storage changes
    const handleStorageChange = (e) => {
      if (e.key === "userPermissions") {
        loadPermissions();
      }
    };
 
    window.addEventListener("storage", handleStorageChange);
 
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
 
  // ===============================
  // SAFE permission check
  // ===============================
  const hasPermission = (permission) => {
    return userPermissions.some(
      (p) => p.trim().toLowerCase() === permission.trim().toLowerCase()
    );
  };
 
  // ===============================
  // ROUTES
  // ===============================
  return (
<Router>
<Routes>
        {/* Public Routes */}
<Route path="/login" element={<LoginPage />} />
<Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
<Route path="/terms-of-service" element={<TOSPage />} />
<Route path="/privacy-policy" element={<PrivacyPage />} />
<Route path="/purchase-subscription" element={<Purchase />} />
 
        {process.env.NODE_ENV === "development" && (
<Route path="/evaluation" element={<EvaluationTest />} />
        )}
 
        {/* Evaluation page only if permission */}
        {/* {hasPermission("Evaluation") && ( */}
<Route
            path="/evaluation/:slug"
            element={
<EvaluationProvider>
<EvaluationPage />
</EvaluationProvider>
            }
          />
        {/* )} */}
 
        {/* ===============================
            MAIN HOME ROUTE (IMPORTANT)
            SAME "/" PATH with permission
           =============================== */}
<Route
  path="/"
  element={
<ProtectedRoute>
<HomeResolver />
</ProtectedRoute>
  }
/>
 
        {/* Other Protected Routes */}
<Route
          path="/loading"
          element={
<ProtectedRoute>
<LoadingScreen targetPath="/" />
</ProtectedRoute>
          }
        />
 
        <Route
          path="/learning-modules"
          element={
<ProtectedRoute>
<Learning />
</ProtectedRoute>
          }
        />
 
        <Route
          path="/my-evaluation"
          element={
<ProtectedRoute>
<EvaluationProvider>
<EvaluationDashboard />
</EvaluationProvider>
</ProtectedRoute>
          }
        />
 
        <Route
          path="/report-dashboard/:slug"
          element={
<ProtectedRoute>
<ReportPage />
</ProtectedRoute>
          }
        />
 
        <Route
          path="/account"
          element={
<ProtectedRoute>
<AccountPage />
</ProtectedRoute>
          }
        />
 
        <Route
          path="/user-management"
          element={
<ProtectedRoute>
<UserManagement />
</ProtectedRoute>
          }
        />
 
        <Route
          path="/role-management"
          element={
<ProtectedRoute>
<RoleManagement />
</ProtectedRoute>
          }
        />
</Routes>
</Router>
  );
}
 
export default App;